import React from 'react';
import { Box } from '@mui/material';
import EmployeeMessagesPanel from '../components/hr/EmployeeMessagesPanel';

const EmployeeMessagesAdmin = () => (
  <Box>
    <EmployeeMessagesPanel />
  </Box>
);

export default EmployeeMessagesAdmin;
